import { useMemo } from "react";
import { QuestionnaireContent, UserAnswer } from "core/types";

export const useQuestionnaireScores = (
  questionnaire?: QuestionnaireContent,
  questionnaireAnswers?: UserAnswer[],
) => {
  const questionIdToAnswerIdMap = useMemo(() => {
    return (
      questionnaireAnswers?.reduce<Record<string, string>>((acc, curr) => {
        acc[curr.questionId] = curr.answerId;
        return acc;
      }, {}) ?? {}
    );
  }, [questionnaireAnswers]);

  const maxScore = useMemo(() => {
    if (!questionnaire?.questions) return 0;

    return questionnaire?.questions.reduce<number>((acc, curr) => {
      return acc + Math.max(...curr.optionGroup.options.map((o) => o.score));
    }, 0);
  }, [questionnaire]);

  const resultScore = useMemo(() => {
    if (!questionnaire?.questions) return 0;

    return questionnaire?.questions.reduce<number>((acc, curr) => {
      return (
        acc +
        (curr.optionGroup.options.find(
          (o) => o.optionId === questionIdToAnswerIdMap[curr.questionId],
        )?.score ?? 0)
      );
    }, 0);
  }, [questionnaire, questionIdToAnswerIdMap]);
  return { resultScore, maxScore };
};
